"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var router_deprecated_1 = require('@angular/router-deprecated');
var http_1 = require('@angular/http');
var clientinfo_service_1 = require('../../clientinfo.service');
var core_2 = require('angular2-cookie/core');
var DeviceService_1 = require('../../services/DeviceService');
var phone_input_1 = require('./phone-input/phone-input');
var io = require('socket.io-client/lib');
var PhoneCallComponent = (function () {
    function PhoneCallComponent(router, clientInfo, http, _cookieService, deviceService) {
        this.router = router;
        this.clientInfo = clientInfo;
        this.http = http;
        this._cookieService = _cookieService;
        this.deviceService = deviceService;
        this.phone = '';
    }
    // Wait for response from authorization service to show success page
    PhoneCallComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addUserToken();
        this.phone = this.clientInfo.maskedPhone
            || this._cookieService.get('maskedPhone')
            || '';
        this.deviceService.getDevice().then(function (device) {
            _this.device = device.json();
        });
        this._timeOut = setTimeout(function () {
            _this.clientInfo.socket.emit('grantAccessTimeout', _this.clientInfo.userOrder);
            _this.clearData();
            _this.router.navigate(['Error']);
        }, 120000);
        this._interval = setInterval(function () {
            var token = _this._cookieService.get('token' + _this.clientInfo.userOrder.service_id);
            if (!_this.clientInfo.socket) {
                _this.clientInfo.socket = io('http://wifi42.ru');
            }
            _this.clientInfo.socket.emit('amiAuthentificated', token);
            _this.clientInfo.socket.on('haveSession', function (data) {
                console.log('haveSession emited');
                if (data.auth) {
                    _this.clearData();
                    _this.clientInfo.socket.removeListener('grantAccessTimeout');
                    clearTimeout(_this._timeOut);
                    _this.router.navigate(['Success']);
                }
            });
        }, 5000);
        this.clientInfo.socket.on('grantAccess', function (data) {
            clearTimeout(_this._timeOut);
            _this._cookieService.put('grantAccess', 'true');
            _this.clientInfo.grantAccess = true;
            _this.router.navigate(['Success']);
        });
    };
    PhoneCallComponent.prototype.canCall = function () {
        return this.device ? this.device.canCall : false;
    };
    PhoneCallComponent.prototype.makeCall = function () {
        var callLink = 'tel:+73842901911';
        window.open(callLink, '_top');
    };
    PhoneCallComponent.prototype.cancel = function () {
        clearTimeout(this._timeOut);
        this.clearData();
        this.clientInfo.socket.removeListener('grantAccessTimeout');
        this.router.navigate(['Welcome']);
    };
    PhoneCallComponent.prototype.clearData = function () {
        clearInterval(this._interval);
        this.clientInfo.userOrder.phone = '';
        this.clientInfo.socket.removeListener('grantAccess');
        this.clientInfo.socket.removeListener('haveSession');
        this._cookieService.remove('grantAccess');
        this.clientInfo.grantAccess = false;
    };
    PhoneCallComponent.prototype.addUserToken = function () {
        var _this = this;
        var headers = new http_1.Headers();
        headers.append('Content-Type', 'application/json');
        this.http.post('/api/user/addtoken', JSON.stringify(this.clientInfo.userOrder), { headers: headers })
            .map(function (response) { return response.json(); })
            .subscribe(function (data) {
            _this._cookieService.put("token" + data.service_id, data.token);
            if (!_this._cookieService.get('phone')) {
                _this._cookieService
                    .put('phone', _this.clientInfo.userOrder.phone);
                _this._cookieService
                    .put('maskedPhone', _this.clientInfo.maskedPhone);
            }
        });
    };
    PhoneCallComponent.prototype.oldMethodCallButton = function () {
        return this.device ? this.device.oldMethodCallButton : false;
    };
    PhoneCallComponent = __decorate([
        core_1.Component({
            selector: 'smartwifi-phonecall',
            template: require('./phonecall.template.html'),
            directives: [router_deprecated_1.ROUTER_DIRECTIVES, phone_input_1.PhoneInput],
            providers: [core_2.CookieService]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_deprecated_1.Router !== 'undefined' && router_deprecated_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof clientinfo_service_1.ClientInfoService !== 'undefined' && clientinfo_service_1.ClientInfoService) === 'function' && _b) || Object, (typeof (_c = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _c) || Object, (typeof (_d = typeof core_2.CookieService !== 'undefined' && core_2.CookieService) === 'function' && _d) || Object, (typeof (_e = typeof DeviceService_1.DeviceService !== 'undefined' && DeviceService_1.DeviceService) === 'function' && _e) || Object])
    ], PhoneCallComponent);
    return PhoneCallComponent;
    var _a, _b, _c, _d, _e;
}());
exports.PhoneCallComponent = PhoneCallComponent;



/*****************
 ** WEBPACK FOOTER
 ** ./app/steps/phonecall/phonecall.component.ts
 ** module id = 941
 ** module chunks = 1
 **/